import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-724ce5e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "epc-container"
}
const _hoisted_2 = {
  key: 0,
  class: "epc-group"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header" }, "Energy Efficiency", -1))
const _hoisted_4 = { class: "input-fields" }
const _hoisted_5 = { class: "epc-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "header" }, "Environmental Impact", -1))
const _hoisted_7 = { class: "input-fields" }

import { PropType, computed } from 'vue';
import { Certificates } from 'acquaint-api/models/Certificates'
import NumberBoxField from '../ui/inputs/number-box-field.vue';
import { FieldSize } from '@/enums/system/FieldSize';
import { PropertyUsages } from '@/enums/properties/PropertyUsages';


export default /*#__PURE__*/_defineComponent({
  __name: 'epc-input',
  props: {
    /** 
     * The value of the component, used with `v-model`. 
     * This represents the certificates data being managed.
     * @type {Certificates}
     * @required
     */
    modelValue: {
        type: Object as PropType<Certificates>,
        required: true
    },
    /** 
     * Defines the usage type of the property.
     * This is typically an enumeration or numeric identifier indicating how the property is used.
     * @type {number}
     * @required
     */
    propertyUsage: {
        type: Number,
        required: true
    },
    /** 
     * A validation group identifier used for form validation purposes.
     * This helps in grouping fields under a specific validation rule set.
     * @type {string}
     * @default ''
     */
    validationGroup: {
        type: String,
        default: ''
    }
},
  emits: [
    /** 
     * Emitted when the `modelValue` is updated, typically triggered when a selection changes.
     * @event update:modelValue
     * @param {Certificates} value - The new value to be updated in the model.
     */
    'update:modelValue'
],
  setup(__props, { emit }) {

const props = __props;





const certificate = computed({
    get: () => props.modelValue,
    set: (value: Certificates) => emit('update:modelValue', value)
});


return (_ctx: any,_cache: any) => {
  return (certificate.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.propertyUsage == _unref(PropertyUsages).Residential)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createVNode(NumberBoxField, {
                  modelValue: certificate.value.eerCurrent,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((certificate.value.eerCurrent) = $event)),
                  label: "Current",
                  width: _unref(FieldSize).Small,
                  "max-value": 100,
                  "validation-group": __props.validationGroup
                }, null, 8, ["modelValue", "width", "validation-group"]),
                _createVNode(NumberBoxField, {
                  modelValue: certificate.value.eerPotential,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((certificate.value.eerPotential) = $event)),
                  label: "Potential",
                  width: _unref(FieldSize).Small,
                  "max-value": 100,
                  "validation-group": __props.validationGroup
                }, null, 8, ["modelValue", "width", "validation-group"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(NumberBoxField, {
              modelValue: certificate.value.eirCurrent,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((certificate.value.eirCurrent) = $event)),
              label: "Current",
              width: _unref(FieldSize).Small,
              "max-value": 100,
              "validation-group": __props.validationGroup
            }, null, 8, ["modelValue", "width", "validation-group"]),
            (__props.propertyUsage == _unref(PropertyUsages).Residential)
              ? (_openBlock(), _createBlock(NumberBoxField, {
                  key: 0,
                  modelValue: certificate.value.eirPotential,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((certificate.value.eirPotential) = $event)),
                  label: "Potential",
                  width: _unref(FieldSize).Small,
                  "max-value": 100,
                  "validation-group": __props.validationGroup
                }, null, 8, ["modelValue", "width", "validation-group"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})